export default {
  reviewDetail: {
    component: () =>
      import("@/mods/archive/dataReview/detailView/DataReviewDetail"),
  },
};
